import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import PredefinedJob from "../../api/PredefinedJob";
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import Loading from "../../components/Loading";
import { DashboardLayout } from "../../components/organisms/Layout";
import { addIcon } from "../../assets/images";
import Table from "../../components/atoms/Tables/Table";
import IconSelector from "../../components/atoms/Selector/IconSelector";

const PreDefinedJobs = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    document.title = "HeyHire Portal-Position Templates";
    loadPredefinedJobs();
  }, []);

  const loadPredefinedJobs = () => {
    setLoading(true);
    PredefinedJob.getAll()
      .then((response) => setJobs(response.data.data))
      .catch((error) => {
        if (error?.response?.status !== 403) {
          toast.error(t("common.something-went-wrong"));
        }
      })
      .finally(() => setLoading(false));
  };

  const deleteJob = (id) => {
    PredefinedJob.delete(id)
      .then(() => {
        const dataCopy = jobs.slice();
        dataCopy.splice(
          jobs.findIndex((item) => item?.id === id),
          1
        );
        setJobs(dataCopy);
        toast.success(t("Job Deleted Successfully"));
      })
      .catch((error) => {
        if (error?.response?.status !== 403) {
          toast.error(t("common.something-went-wrong"));
        }
      });
  };

  return (
    <DashboardLayout darmo={true}>
      <div className="pb-12">
        <Table
          isLoading={loading}
          mainHeader={t("pre-defined-jobs.pre-defined-jobs")}
          headers={[
            t("pre-defined-jobs.position"),
            t("pre-defined-jobs.type"),
            t("common.category"),
            t("common.status"),
            t("common.action"),
          ]}
          data={jobs?.map((job, index) => (
            <tr
              key={index}
              className="hover:bg-gray-50 transition-colors duration-150"
            >
              <td className="whitespace-nowrap px-6 py-4 text-sm">
                <div className="text-gray-900 font-semibold">
                  {job.title}
                </div>
              </td>
              <td className="whitespace-nowrap px-6 py-4 text-sm">
                <div className="text-gray-700">
                  {job.availability}
                </div>
              </td>
              <td className="whitespace-nowrap px-6 py-4 text-sm">
                <div className="text-gray-700">
                  {job?.category[0]?.name || "-"}
                </div>
              </td>
              <td className="whitespace-nowrap px-2 sm:px-3 py-2.5 sm:py-3 text-sm md:text-base">
                <span className="inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-sm font-medium text-green-700 ring-1 ring-inset ring-green-600/20">
                  Active
                </span>
              </td>
              <td className="whitespace-nowrap px-2 sm:px-3 py-2.5 sm:py-3 text-sm md:text-base">
                <IconSelector
                  menus={[
                    {
                      label: t("common.edit"),
                      action: () => navigate(`/predefined-jobs/edit/${job.id}`),
                    },
                    {
                      label: t("common.delete"),
                      action: () => deleteJob(job?.id),
                    },
                  ]}
                />
              </td>
            </tr>
          ))}
          emptyState={
            !loading && jobs?.length === 0 && (
              <div className="text-center py-12">
                <svg
                  className="mx-auto h-12 w-12 text-gray-400"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M9 13h6m-3-3v6m-9 1V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"
                  />
                </svg>
                <h3 className="mt-2 text-sm font-medium text-gray-900">
                  {t("pre-defined-jobs.no-jobs-found")}
                </h3>
                <p className="mt-1 text-sm text-gray-500">
                  {t("pre-defined-jobs.no-jobs-description")}
                </p>
              </div>
            )
          }
          buttonData={
            <button
              onClick={() => navigate("/predefined-jobs/add")}
              className="w-full sm:w-auto flex-shrink-0 cursor-pointer flex justify-center items-center rounded-lg bg-primary-500 px-6 h-10 text-sm font-semibold text-white shadow-sm hover:bg-primary-400 transition-all duration-200"
            >
              <img src={addIcon} alt="add" className="mr-2 w-4 h-4" />
              Add Job Template
            </button>
          }
        />
      </div>
    </DashboardLayout>
  );
};

export default PreDefinedJobs;
